import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Divider, Row, Col } from 'antd';
import { Edit as EditIcon } from 'common/components/svgs';
import moment from 'moment';
import generatePath from '~settings/routing';
import DepositTable from '~pages/payment/long-tail/setup/table/deposit-table';
import { connect } from 'react-redux';
import queryString from 'query-string';
import RentPaymentTable from '~pages/payment/long-tail/setup/rent-payment/table';
import { paymentPlanCategoryType } from '~constants';
import { decode } from 'js-base64';
import { getSafeHtml } from 'common/helpers/safeHtml';

const mapStateToProps = state => {
  const payment = state.payment.toJS();

  return {
    paymentPlan: payment.longtail.paymentPlan,
  };
};

@connect(mapStateToProps, null)
@withTranslation()
export default class EnablePayments extends React.Component {
  constructor(props) {
    super(props);
    this.routingMapping = {
      'initial-setup': 'paymentInitialSetup',
      deposit: 'paymentDeposit',
      fee: 'paymentFee',
      'rent-payment': 'paymentRentPayment',
    };
  }

  handleEditBtn = currentPageSlug => {
    const search = queryString.parse(this.props.location.search);

    this.props.history.push(
      generatePath(this.routingMapping[currentPageSlug], {}, { id: search.id }),
    );
  };

  getEffictiveDate = () => {
    const { paymentPlan, t } = this.props;

    const startDate = paymentPlan.startDate
      ? moment(paymentPlan.startDate).format('YYYY-MM-DD HH:mm:ss')
      : '~';

    let endDate = '~';
    if (paymentPlan.endDate) {
      const endDateFormate = moment(paymentPlan.endDate);
      endDate =
        endDateFormate.year() >= 9999
          ? t('landlord.payment.long_tail.open_end.field')
          : endDateFormate.format('YYYY-MM-DD HH:mm:ss');
    }

    if (paymentPlan && (paymentPlan.startDate || paymentPlan.endDate)) {
      return startDate.concat(' - ', endDate);
    }

    return '-';
  };
  createDataSource = paymentPlan => {
    const { deposits, fees } = paymentPlan;
    deposits?.forEach((deposit, index) => {
      if (index == 0) {
        deposit.cannotDelete = true;
      }
      deposit.type = 'deposit';
      deposit.timestamp = Date.parse(new Date(deposit.createdAt));
    });
    fees?.forEach(fee => {
      fee.type = 'fee';
      fee.timestamp = Date.parse(new Date(fee.createdAt));
    });
    const newArr = deposits.concat(fees).sort((a, b) => b.timestamp - a.timestamp);

    return newArr;
  };
  render() {
    const { t, paymentPlan, hasKeyProperty, paymentplanCategory, paymentOnline } = this.props;
    const depositAndFeesDatas = paymentPlan ? this.createDataSource(paymentPlan) : [];
    return (
      <div className="enable-payments">
        <span className="enable-payments__tips">
          {getSafeHtml(t('landlord.payment.long_tail.enable_payments.tips'))}
        </span>
        <Divider
          style={{
            margin: '24px 0 32px',
          }}
        />
        <div className="enable-payments__deposit-payments-are">
          <h4 className="enable-payments__title">
            {t('basic_details')}
            <button
              className="enable-payments__btn"
              onClick={() => {
                this.handleEditBtn('initial-setup');
              }}
            >
              <EditIcon className="enable-payments__btn-icon" />
              {t('landlord.payment.button.edit')}
            </button>
          </h4>
          <Row gutter={16}>
            <Col span={12} className="enable-payments__field">
              <label className="enable-payments__label">
                {t('landlord.payment.long_tail.payment_plan_name.field')}:
              </label>
              {paymentPlan && paymentPlan.name ? paymentPlan.name : '-'}
            </Col>
            <Col span={12} className="enable-payments__field">
              <label className="enable-payments__label">
                {t('landlord.payment.long_tail.payment_currency.field')}:
              </label>
              {paymentPlan && paymentPlan.currency ? paymentPlan.currency : '-'}
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12} className="enable-payments__field">
              <label className="enable-payments__label">
                {t('landlord.payment.long_tail.description.field')}:
              </label>
              {paymentPlan && paymentPlan.description ? paymentPlan.description : '-'}
            </Col>
            <Col span={12} className="enable-payments__field">
              <label className="enable-payments__label">
                {t('landlord.payment.long_tail.effictive_date.field')}:
              </label>
              {paymentPlan ? this.getEffictiveDate() : '-'}
            </Col>
          </Row>
          <If condition={paymentOnline && hasKeyProperty}>
            <Row gutter={16}>
              <Col span={12} className="enable-payments__field">
                <label className="enable-payments__label">
                  {t('landlord.payment.long_tail.initial_setup.label.student_must_pay')}:
                </label>
                {paymentplanCategory === paymentPlanCategoryType.DEPOSIT_IS_REQUIRED
                  ? t('landlord.payment.setup_status.deposit')
                  : t('landlord.payment.setup_status.rent_payment')}
              </Col>
            </Row>
          </If>
          <Row gutter={16}>
            <Col span={12} className="enable-payments__field">
              <label className="enable-payments__label">ID:</label>
              {JSON.parse(decode(paymentPlan.id))?.id ?? '-'}
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12} className="enable-payments__field">
              <label className="enable-payments__label">
                {t('landlord.payment.long_tail.applied_properties.field')}:
              </label>
              {paymentPlan && paymentPlan.properties && paymentPlan.properties.length > 0
                ? paymentPlan.properties.map(item => item.name).join(', ')
                : '-'}
            </Col>
          </Row>
          <If condition={!paymentOnline}>
            <Row gutter={16}>
              <Col span={12} className="enable-payments__field">
                <label className="enable-payments__label">
                  {t('landlord.payment.long_tail.student_must_payment.hint')}:
                </label>
                {t('landlord.booking.selected.button.no')}
              </Col>
            </Row>
          </If>
        </div>

        <div className="enable-payments__deposit">
          <h4 className="enable-payments__title">
            {t('landlord.payment.long_tail.deposit_or_fees.title')}
            <button
              className="enable-payments__btn"
              onClick={() => {
                this.handleEditBtn('deposit');
              }}
            >
              <EditIcon className="enable-payments__btn-icon" />
              {t('landlord.payment.button.edit')}
            </button>
          </h4>
          <DepositTable
            t={t}
            isView
            dataSource={depositAndFeesDatas}
            currency={paymentPlan ? paymentPlan.currency : ''}
          />
        </div>

        <div className="enable-payments__instalment-setup">
          <h4 className="enable-payments__title">
            {t('rent_payment')}
            <button
              className="enable-payments__btn"
              onClick={() => {
                this.handleEditBtn('rent-payment');
              }}
            >
              <EditIcon className="enable-payments__btn-icon" />
              {t('landlord.payment.button.edit')}
            </button>
          </h4>
          <RentPaymentTable
            dataSource={paymentPlan?.instalments || []}
            paymentOnline={paymentOnline}
          />
        </div>
      </div>
    );
  }
}

EnablePayments.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  paymentPlan: PropTypes.object,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};

EnablePayments.defaultProps = {
  t: () => {},
  history: {
    push: () => {},
  },
  paymentPlan: {},
};
